import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { FocusGrid, ContainerGrid } from '#client/components/Grid';

import { ImageWrapperStyled, Wrapper } from './CheckDepositIntro.styles';
import EducationStepLabel from './EducationStepLabel';
import { EducationSteps } from './EducationSteps';

const stepsEducation = () => [
  { step: EducationSteps.prepTheCheck },
  { step: EducationSteps.positionInsideTheLines },
  { step: EducationSteps.followTheGuidelines },
  { step: EducationSteps.WhenToAccessFunds }
];

const stepsBackOfCheck = () => [{ step: EducationSteps.prepTheCheck }];

const CheckDepositIntro = ({ isCheckDepositEducation }) => {
  const stepsToRender = isCheckDepositEducation ? stepsEducation() : stepsBackOfCheck();
  return (
    <ContainerGrid>
      <FocusGrid>
        <Wrapper>
          {stepsToRender.map(({ step }, i) => (
            <Stack
              aria-label="education step"
              key={`${step?.title}_${i + 1}`}
              pb="40px"
              spacing="16px"
            >
              <EducationStepLabel
                number={i + 1}
                step={step}
                total={stepsToRender.length}
              />
              {step?.content && (
                <Stack
                  pl={isCheckDepositEducation ? 5 : 0}
                  spacing="16px"
                >
                  {step.content()}
                </Stack>
              )}
              {step?.image && <ImageWrapperStyled>{step.image}</ImageWrapperStyled>}
            </Stack>
          ))}
        </Wrapper>
      </FocusGrid>
    </ContainerGrid>
  );
};

CheckDepositIntro.propTypes = {
  isCheckDepositEducation: PropTypes.bool
};

export default CheckDepositIntro;
